import { styled, Typography } from '@mui/material';

export const Label = styled(Typography)`
  min-width: fit-content;
  text-wrap: balance;
  width: min-content;
  font-weight: 600;
`;
